import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { Recall } from '@rock/types';
import type { FC } from 'react';
import { RecallRows } from './RecallsTable';

export const StalledRecallsTab: FC<{ stalled: Recall[] | undefined; failed: boolean }> = ({ stalled, failed }) => (
    <Card>
        <CardHeader>
            <CardTitle>Stalled before review</CardTitle>
            <CardDescription>
                Still new, or typed with no rules, and untouched for longer than any pipeline run takes. The daily sync
                retries these; open one to reclassify or reprocess it by hand.
            </CardDescription>
        </CardHeader>
        <CardContent>
            {stalled && stalled.length > 0 ? (
                <RecallRows recalls={stalled} />
            ) : (
                <div className="section-description">
                    {failed ? 'Couldn’t load recalls.' : stalled ? 'No stalled recalls.' : 'Loading recalls…'}
                </div>
            )}
        </CardContent>
    </Card>
);
